(function () {
  'use strict';

  document.querySelectorAll('[data-ll-market]').forEach(function (root) {
    if (root.dataset.llMarketReady === 'true') return;
    root.dataset.llMarketReady = 'true';

    var opener = root.querySelector('[data-ll-market-open]');
    var dialog = root.querySelector('[data-ll-market-dialog]');
    var panel = dialog && dialog.querySelector('[role="dialog"]');
    var closeButtons = dialog && dialog.querySelectorAll('[data-ll-market-close]');
    var closeTimer = null;

    if (!opener || !dialog || !panel) return;

    function focusable() {
      return Array.prototype.slice.call(panel.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
        .filter(function (element) { return !element.hidden && !(element.closest && element.closest('[hidden]')); });
    }

    function openDialog() {
      window.clearTimeout(closeTimer);
      dialog.hidden = false;
      opener.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ll-market-open');
      window.requestAnimationFrame(function () {
        dialog.classList.add('is-open');
        var targets = focusable();
        if (targets.length) targets[0].focus();
      });
    }

    function closeDialog() {
      dialog.classList.remove('is-open');
      opener.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('ll-market-open');
      closeTimer = window.setTimeout(function () {
        dialog.hidden = true;
        opener.focus();
      }, 180);
    }

    opener.addEventListener('click', openDialog);
    closeButtons.forEach(function (button) { button.addEventListener('click', closeDialog); });

    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDialog();
        return;
      }
      if (event.key !== 'Tab') return;
      var targets = focusable();
      if (!targets.length) return;
      var first = targets[0];
      var last = targets[targets.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    /* A long country list filters as the shopper types; accents and case are ignored. */
    var search = root.querySelector('[data-ll-market-search]');
    if (search) {
      var options = Array.prototype.slice.call(root.querySelectorAll('[data-ll-market-option]'));
      var groups = Array.prototype.slice.call(root.querySelectorAll('[data-ll-market-group]'));
      var empty = root.querySelector('[data-ll-market-empty]');
      var fold = function (text) {
        return String(text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      };
      search.addEventListener('input', function () {
        var query = fold(search.value);
        var shown = 0;
        options.forEach(function (option) {
          var match = !query || fold(option.dataset && option.dataset.countryName).indexOf(query) !== -1 || fold(option.value) === query;
          option.hidden = !match;
          if (match) shown += 1;
        });
        groups.forEach(function (group) {
          group.hidden = !Array.prototype.some.call(group.querySelectorAll('[data-ll-market-option]'), function (option) { return !option.hidden; });
        });
        if (empty) empty.hidden = shown !== 0;
      });
      search.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') event.preventDefault();
      });
    }

    /* Pages the e-book-only market can show: the menu links (snippets/ll-ebook-only-link.liquid),
       plus the basket, search, the account area and the policies, which work in any market. */
    function ebookPage(path) {
      return path === '/' || path === '/collections/books-for-adults' || path === '/collections/astro-books' || /^\/pages\/./.test(path || '') || /^\/products\/[a-z0-9][a-z0-9-]*-digital$/.test(path || '')
        || /^\/(?:cart|search|account)(?:\/|$)/.test(path || '') || /^\/policies\/./.test(path || '');
    }

    var form = root.querySelector('.ll-market__form');
    if (form) {
      form.addEventListener('submit', function (event) {
        var chart = document.querySelector('[data-ll-natal][data-product-kind]');
        var starbook = document.querySelector('[data-ll-starbook]');
        var submitter = event.submitter || {};
        var country = submitter.value;
        /* Shopper countries that buy the UK edition (src/markets/editions.json). */
        var UK_EDITION_COUNTRIES = ['GB', 'AU', 'DE', 'NZ', 'CA', 'SG'];
        var edition = country === 'US' ? 'US' : UK_EDITION_COUNTRIES.indexOf(country) !== -1 ? 'GB' : '';
        /* The International market sells the e-books only, whatever edition the country prints. */
        var ebookMarket = root.dataset && root.dataset.ebookMarket;
        var ebookOnly = Boolean(ebookMarket) && Boolean(submitter.dataset) && submitter.dataset.market === ebookMarket;
        var destination = null;
        if (ebookOnly) {
          /* A Star Book page moves to its cover's e-book; a page that market can show stays;
             anything else (a printed book, a chart) goes to the homepage, which leads with the e-book. */
          if (starbook) {
            var ebookUrls = {};
            try { ebookUrls = JSON.parse(starbook.querySelector('[data-starbook-product-urls]')?.textContent || '{}'); } catch (error) { ebookUrls = {}; }
            var ebookUrl = ebookUrls && ebookUrls.digital && ebookUrls.digital[starbook.dataset.currentCover || 'n1-midnight-wheel'];
            destination = ebookUrl && /^\/products\/written-in-your-stars-(?:(?:sage-bookplate|oxblood)-)?digital$/.test(ebookUrl) ? ebookUrl : '/';
          } else if (!ebookPage(window.location && window.location.pathname)) {
            destination = '/';
          }
        } else if (starbook) {
          var cover = starbook.dataset.currentCover || 'n1-midnight-wheel';
          var productUrls = {};
          try { productUrls = JSON.parse(starbook.querySelector('[data-starbook-product-urls]')?.textContent || '{}'); } catch (error) { productUrls = {}; }
          if (!productUrls || typeof productUrls !== 'object') productUrls = {};
          /* The other UK-edition countries buy the UK edition (with its PDF),
             but only once that cover's UK product carries the destination's
             market tag (ukEditionMarkets): before then it is not offered there.
             Until then, and anywhere else, they get the E-book, or the
             unavailable page when there is none. */
          if (country === 'GB' || country === 'US') {
            destination = productUrls.physical && productUrls.physical[country] && productUrls.physical[country][cover] || null;
          } else if (edition === 'GB') {
            var ukMarkets = productUrls.ukEditionMarkets && productUrls.ukEditionMarkets[cover];
            var ukReady = Array.isArray(ukMarkets) && ukMarkets.indexOf(country) !== -1;
            destination = ukReady && productUrls.physical && productUrls.physical.GB && productUrls.physical.GB[cover]
              || productUrls.digital && productUrls.digital[cover]
              || '/pages/starbook-market-unavailable';
          } else {
            destination = productUrls.digital && productUrls.digital[cover] || '/pages/starbook-market-unavailable';
          }
          if (destination && !/^\/products\/written-in-your-stars-(?:(?:sage-bookplate|oxblood)-)?(?:uk|us|digital)$/.test(destination) && destination !== '/pages/starbook-market-unavailable') destination = null;
        }
        if (edition && !ebookOnly) {
          /* Product pages declare their UK (en-GB) and US (en-US) twins; every
             UK-edition country follows the UK twin. */
          var alternate = document.querySelector('link[rel="alternate"][hreflang="en-' + edition + '"]');
          if (!destination && alternate && (!chart || country === 'US')) {
            try {
              var target = new URL(alternate.getAttribute('href'), window.location.origin);
              if (target.origin === window.location.origin && /^\/products\/[a-z0-9][a-z0-9-]*$/.test(target.pathname)) destination = target.pathname;
            } catch (error) { /* Invalid destinations retain the existing fallback. */ }
          }
          if (!destination && chart && country === 'US') {
            var handle = chart.dataset.productKind === 'astrocartography'
              ? 'personalised-astrocartography-chart'
              : chart.dataset.productAudience === 'kids' ? 'personalised-baby-kids-natal-chart' : 'personalised-natal-chart-print';
            destination = '/products/' + handle;
          }
        }
        if (!destination && chart && country !== 'US' && !ebookOnly) destination = '/pages/wall-art-us-only';
        if (destination) {
          var returnTo = form.querySelector('[name="return_to"]');
          if (!returnTo) { returnTo = document.createElement('input'); returnTo.type = 'hidden'; returnTo.name = 'return_to'; form.appendChild(returnTo); }
          returnTo.value = destination;
        }
        form.setAttribute('aria-busy', 'true');
      });
    }
  });
})();
